import React, { useEffect, useState } from "react";
import { Button, Container, Modal, Spinner, Table } from "react-bootstrap";
import { TextField, Typography } from "@mui/material";
import TableContent from "../../table/table";
import Loader from "../../../loader/loader";
import {
  CreateJopTitleAction,
  DeleteJopTitleAction,
  GetAllJopTitleAction,
  UpdateJopTitleAction,
} from "../../../../redux/actions/JopTitleAction";
import { useDispatch, useSelector } from "react-redux";
import notify from "../../../Notifcation";
import { ToastContainer } from "react-toastify";
const NameJob = () => {
  const [JopTitle, setJopTitle] = useState("");
  const [Note, setNote] = useState("");
  const [loading, setLoading] = useState(true);
  const [isPress, setIsPress] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [IdJopTitle, setIdJopTitle] = useState("");
  const [Eye, setEye] = useState(false);
  const [showDelete, setshowDelete] = useState(false);
  const handleCloseDelete = () => setshowDelete(false);
  const handleShoweDelete = (itemid) => {
    setshowDelete(true);
    setIdJopTitle(itemid);
  };
  const handelDeleteItem = async () => {
    setIsPress(true);
    setLoading(true);
    await dispatch(DeleteJopTitleAction(IdJopTitle));
    setLoading(false);
    setIdJopTitle("");
    setshowDelete(false);
    setIsPress(false);
  };
  const ALL = useSelector((state) => state.JopTitleR.GetJopTitle);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(GetAllJopTitleAction());
  }, []);
  const handlesubmit = async (e) => {
    e.preventDefault();
    if (JopTitle === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setIsPress(true);
    setLoading(true);
    await dispatch(
      CreateJopTitleAction({
        name: JopTitle,
        note: Note,
      })
    );
    setJopTitle("");
    setNote("");
    setIdJopTitle("");
    setIsPress(false);
    setLoading(false);
  };
  const handleUpdate = async (e) => {
    e.preventDefault();
    if (JopTitle === "") {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setIsPress(true);
    setLoading(true);
    await dispatch(
      UpdateJopTitleAction({
        id: IdJopTitle,
        name: JopTitle,
        note: Note,
      })
    );
    setJopTitle("");
    setNote("");
    setIdJopTitle("");
    setIsEdit(false);
    setIsPress(false);
    setLoading(false);
  };
  const Update = (item) => {
    setJopTitle(item.name);
    setNote(item.note);
    setIdJopTitle(item.id);
    setIsEdit(true);
    setEye(false);
  };
  const HandleEye = (item) => {
    setJopTitle(item.name);
    setNote(item.note);
    setIdJopTitle(item.id);
    setIsEdit(false);
    setEye(true);
  };
  const res = useSelector((state) => state.JopTitleR.AddJopTitle);
  const UP = useSelector((state) => state.JopTitleR.UpdateJopTitle);
  const DEL = useSelector((state) => state.JopTitleR.DeleteJopTitle);

  useEffect(() => {
    if (loading === false) {
      setTimeout(() => setLoading(true), 2000);
      if (res) {
        if (res.status === 200 || res.status === 201) {
          if (
            res.data &&
            res.data.responseMessage === "Great, JopTitle created Successfully"
          ) {
            dispatch(GetAllJopTitleAction());
            notify("تم اضافة البيانات بنجاح", "success");
          }
        } else if (res.status !== 200 || res.status !== 201) {
          // if (res.data && res.data.responseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
      if (UP) {
        if (UP.data.statusCode === 200 || UP.data.statusCode === 201) {
          if (
            UP.data &&
            UP.data.responseMessage === "Great, jopTitle updated Successfully"
          ) {
            dispatch(GetAllJopTitleAction());
            notify("تم تحديث البيانات بنجاح", "success");
          }
        } else if (UP.statusCode !== 200 || UP.statusCode !== 201) {
          // if (res.data && res.data.responseMessage==="PhoneNumber or Password is incorrect!") {
          //   notify("خطأ في كلمة السر او رقم الهاتف", "error");
          // }
          // else
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }

      if (DEL) {
        if (DEL.statusCode === 200 || DEL.statusCode === 201) {
          if (
            DEL &&
            DEL.responseMessage === "Great, jopTitle Deleted Successfully"
          ) {
            dispatch(GetAllJopTitleAction());
            notify("تم حذف البيانات بنجاح", "success");
          }
        } else if (DEL.statusCode !== 200 || DEL.statusCode !== 201) {
          notify("حدث خطأ حاول مرة اخرى", "error");
        }
        // setLoading(true);
      }
    }
  }, [loading]);
  return (
    <>
      <div className="enterr">
        <Container>
          <div className="inputs-container">
            <div className="inp-container">
              <TextField
                label={
                  <Typography sx={{ fontSize: "17", fontFamily: "Almarai" }}>
                    اسم الوظيفة
                    <span style={{ color: "red", fontSize: "21px" }}>*</span>
                  </Typography>
                }
                inputProps={{ maxLength: 120 }}
                value={JopTitle}
                onChange={(e) => setJopTitle(e.target.value)}
                variant="outlined"
                //   className="ww"
              />
            </div>
            <div className="inp-container">
              <TextField
                label="ملاحظات"
                variant="outlined"
                inputProps={{ maxLength: 120 }}
                value={Note}
                onChange={(e) => setNote(e.target.value)}
                //   className="ww"
              />
            </div>

            <div className="inp-container"></div>
            <div className="inp-container"></div>
          </div>
          {Eye ? null : (
            <>
              {isEdit ? (
                <>
                  {loading && isPress ? (
                    <button className="buttonadd">
                      <Spinner />
                    </button>
                  ) : (
                    <button className="buttonadd" onClick={handleUpdate}>
                      تعديل
                    </button>
                  )}
                </>
              ) : (
                <>
                  {loading && isPress ? (
                    <button className="buttonadd">
                      <Spinner />
                    </button>
                  ) : (
                    <button className="buttonadd" onClick={handlesubmit}>
                      إضافة
                    </button>
                  )}
                </>
              )}
            </>
          )}{" "}
          {/* <div className="inputs-container">
            <div className="inp-container ">
              {" "}
              <TextField
                
                label="ابحث"
                variant="outlined"
                //   className="ww"
              />
              <i className="ty fa-solid fa-magnifying-glass"></i>
            </div>{" "}
            <div className="inp-container"></div>
            <div className="inp-container"></div>
          </div> */}
        </Container>{" "}
        <Table
          id="my-table"
          className="maint"
          responsive
          striped
          bordered
          hover>
          <thead>
            <tr>
              <th>
                اسم الوظيفة<i className="fa-solid fa-hashtag"></i>
              </th>
              <th>
                ملاحظات <i className="fa-solid fa-hashtag"></i>
              </th>
              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
              <th className="icon-w"> </th>
            </tr>
          </thead>
          <tbody>
            {ALL && ALL.length > 0
              ? ALL.map((item) => (
                  <tr key={item.id}>
                    <td>{item.name}</td>
                    <td>{item.note}</td>
                    <td className="icon-w" onClick={() => Update(item)}>
                      <i
                        className="fa fa-solid fa-pen-to-square icon-blue"
                        style={{ color: "#333" }}></i>
                    </td>
                    <td className="icon-w">
                      {" "}
                      <i
                        onClick={() => handleShoweDelete(item.id)}
                        className="fs fa-solid fa-trash-can icon-red"
                        style={{ color: "#333" }}></i>
                    </td>
                    <td className="icon-w">
                      <i
                        onClick={() => HandleEye(item)}
                        className="fa-solid fa-eye"
                        style={{ color: "#333" }}></i>
                    </td>
                  </tr>
                ))
              : null}
          </tbody>
        </Table>
        <ToastContainer autoClose={1200} />
      </div>
      <div className="mod">
        <Modal
          show={showDelete}
          onHide={handleCloseDelete}
          backdrop="static"
          centered
          contentClassName="cont"
          keyboard={false}
          style={{ width: "100%", margin: "0px auto", textAlign: "center" }}>
          {/* <Modal.Header closeButton>
          <Modal.Title> </Modal.Title>
        </Modal.Header> */}
          <Modal.Body>هل تريد الحذف ؟ </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="close"
              onClick={handleCloseDelete}>
              إغلاق
            </Button>
            <Button
              variant="primary"
              className="edit"
              onClick={handelDeleteItem}>
              موافق
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
};
export default NameJob;
